import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';

export const DescriptionCard = ({ text }) => <Description>{text}</Description>;

const Description = styled.p`
  color: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: 0%;
  font-variant-numeric-fraction: stacked-fractions;

  @media ${Points.laptop_wide} {
    font-size: 18px;
  }
`;
